<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-layout grid-list-md v-if="UserHasRole('Platform')">
        <v-flex xs-4 v-if="!screenIsWideEnough">
          <v-autocomplete
            :items="PartnersList"
            item-text="name"
            item-value="id"
            label="Select a partner"
            solo-inverted
            flat
            dense
            class="ml-3 mr-2 remove-bottom-margin"
            v-model="selected"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs-4>
          <v-text-field
            name="search"
            v-model="search"
            prepend-inner-icon="search"
            flat
            label="Search Partners"
            solo-inverted
            hide-details
            autocomplete="off"
            @keyup="setSearch"
          ></v-text-field>
        </v-flex>
        <v-toolbar-items>
          <v-btn text @click="clearSearch"><v-icon class="mr-1">clear</v-icon> Clear</v-btn>
          <v-btn text @click="toggleShowDisabled">
            <span v-if="PartnersIncludeDisabled">
              <v-icon class="mr-1">format_indent_decrease</v-icon> Hide Disabled
            </span>
            <span v-else><v-icon class="mr-1">format_indent_increase</v-icon> Show Disabled</span>
          </v-btn>
        </v-toolbar-items>
      </v-layout>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height grey lighten-2">
        <v-layout :class="{ 'ml-4': screenIsWideEnough }">
          <v-flex
            style="overflow-y: auto;border-right: 1px solid #ddd;min-width:280px;max-width:280px;width:280px"
            :class="{ hidden: !screenIsWideEnough }"
          >
            <v-list class="pt-0" two-line dense v-if="PartnersList">
              <template v-for="partner in PartnersList">
                <v-list-item
                  :class="{ selected: partner.id === selected.id, disabled: !partner.enabled }"
                  :key="partner.id"
                  @click="selectPartner(partner.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">{{
                      partner.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle v-if="UserHasRole('Platform')">{{ partner.contact }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <template v-for="child in partner.children">
                  <v-list-item
                    :class="{ selected: child.id === selected.id, disabled: !child.enabled }"
                    :key="child.id"
                    @click="selectPartner(child.id)"
                    class="child"
                  >
                    <v-list-item-content class="px-4">
                      <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">
                        {{ child.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>{{ child.contact }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-divider :key="`divider-${partner.id}`"></v-divider>
              </template>

              <v-list-item v-if="PartnersList.length === 0">
                <v-list-item-content>
                  <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis"
                    >No partners found</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>
          <v-flex :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
            <v-card flat class="transparent">
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab v-if="UserHasRole('Platform')" @click="showRightDrawer = false">Stats</v-tab>
                <v-tab @click="showRightDrawer = false">Details</v-tab>
                <v-tab v-if="UserHasRole('Platform')" @click="showRightDrawer = false">Web Content</v-tab>
                <v-tab v-if="!UserHasRole('Provider')" @click="showRightDrawer = false">Communications</v-tab>
                <v-tab @click="showRightDrawer = false">Users</v-tab>
                <v-tab v-if="UserHasRole('Platform')" @click="showRightDrawer = false">Funders</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs" class="grey lighten-2">
                <v-tab-item v-if="UserHasRole('Platform')">
                  <PartnerStats :partnerId="partner.id" />
                </v-tab-item>
                <v-tab-item>
                  <partner-details></partner-details>
                </v-tab-item>
                <v-tab-item v-if="UserHasRole('Platform')">
                  <partner-web-content></partner-web-content>
                </v-tab-item>
                <v-tab-item v-if="!UserHasRole('Provider')">
                  <partner-comms-content></partner-comms-content>
                </v-tab-item>
                <v-tab-item>
                  <partner-users></partner-users>
                </v-tab-item>
                <v-tab-item v-if="UserHasRole('Platform')">
                  <partner-excluded-funders></partner-excluded-funders>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-fab-transition>
      <v-btn
        color="accent darken-1"
        dark
        fab
        fixed
        bottom
        right
        @click.stop="showDialog = true"
        v-if="UserHasRole('Platform')"
      >
        <v-icon>group_add</v-icon>
      </v-btn>
    </v-fab-transition>
    <new-partner-dialog :show.sync="showDialog"></new-partner-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import NewPartnerDialog from './NewPartnerDialog';
import PartnerDetails from './PartnerDetails';
import PartnerExcludedFunders from './PartnerExcludedFunders';
import PartnerWebContent from './PartnerWebContent';
import PartnerCommsContent from './PartnerCommsContent';
import PartnerUsers from './PartnerUsers';
import PartnerStats from './PartnerStats';

export default {
  components: {
    PartnerStats,
    PartnerWebContent,
    PartnerCommsContent,
    PartnerUsers,
    PartnerDetails,
    PartnerExcludedFunders,
    NewPartnerDialog
  },
  name: 'partners',
  data: () => ({
    tabs: null,
    fab: false,
    search: null,
    showDialog: false,
    showRightDrawer: false,
    partner: {
      id: null
    }
  }),
  computed: {
    ...mapGetters([
      'PartnersList',
      'PartnersIncludeDisabled',
      'PartnerMembers',
      'SelectedPartner',
      'UserHasRole',
      'UILeftDrawer'
    ]),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    selected: {
      get() {
        return this.partner;
      },
      set(id) {
        this.partner = this.selectPartner(id);
      }
    }
  },
  methods: {
    ...mapActions([
      'getPartnersList',
      'showDisabledPartners',
      'selectPartner',
      'setPartnerSearch',
      'updateUILeftDrawerState'
    ]),
    clearSearch() {
      this.search = '';
      this.setPartnerSearch('').then(() => this.getPartnersList());
    },
    setSearch: _.debounce(function() {
      this.setPartnerSearch(this.search).then(() => this.getPartnersList());
    }, 350),
    toggleShowDisabled() {
      this.showDisabledPartners(!this.PartnersIncludeDisabled).then(() => this.getPartnersList());
    }
  },
  mounted() {
    this.getPartnersList();
  },
  watch: {
    SelectedPartner: function(partner) {
      this.partner = _.clone(partner);
    }
  }
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.responsive {
  width: 100%;
  max-width: 135px;
  height: auto;
}

.child {
  background: #ddd;
}
.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

td {
  button {
    margin: 0;
    max-width: 250px;
    width: 250px;
  }

  ::v-deep .btn,
  ::v-deep .btn__content {
    width: 250px;
    max-width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    justify-content: start;
    text-align: left;
    display: inline;
    padding: 0;
  }
}

::v-deep th:last-child,
td:last-child {
  padding: 0 24px 0 0 !important;
}

::v-deep table {
  height: calc(100vh - 169px);
  max-height: calc(100vh - 169px);
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;

  .filtered & {
    height: calc(100vh - 267px);
    max-height: calc(100vh - 267px);
  }

  tbody {
    overflow-y: auto;
  }
}

::v-deep .col-selected {
  width: 48px;
  max-width: 48px;
  min-width: 48px;
  padding: 0 12px !important;
}

::v-deep .col-name {
  width: 275px;
  max-width: 275px;
  min-width: 275px;
  padding: 0 24px 0 0 !important;
}

::v-deep .col-funding {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
  padding: 0 24px 0 0 !important;
}

::v-deep .col-owner {
  width: 150px;
  max-width: 150px;
  min-width: 150px;
  padding: 0 24px 0 0 !important;
}

::v-deep .col-status {
  width: 192px;
  max-width: 192px;
  min-width: 192px;
  padding: 0 24px 0 0 !important;
}

::v-deep thead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  tr:first-child {
    border-bottom: none !important;
  }
}

.theme--light {
  .input-group.input-group--solo-inverted.input-group--focused {
    background-color: #fff;
    ::v-deep input,
    ::v-deep .input-group__prepend-icon {
      color: rgba(0, 0, 0, 0.78);
    }
  }
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}

.btn-toggle--selected {
  box-shadow: none;
  .btn--active {
    color: #e91e63;
    > .btn__content:before {
      opacity: 0;
    }
  }
}

.hidden {
  display: none;
}

::v-deep .disabled {
  color: rgba(0, 0, 0, 0.54);
  text-decoration: line-through;
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

::v-deep .remove-bottom-margin .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
